if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    doCartSlider() {
      const cartSliderElement = document.querySelector('.fn-cart-slider');
      const counter = document.querySelector('.fn-counter');
  
      if(cartSliderElement) {
        
        let cartSlider = new Splide( cartSliderElement, {
          pagination: false,
          perPage: 4,
          gap: 55,
          direction: 'rtl',
          breakpoints: {
            1180: {
              perPage: 1,
              gap: 0,
              direction: 'ltr',
            },
          }
        } );

        cartSlider.on( 'mounted move', () => {
          let end = cartSlider.Components.Controller.getEnd() + 1;
          if(counter) {
            counter.innerHTML = (cartSlider.index + 1) + '/' + end;
          }
        });

        cartSlider.mount();
      }
    }

    checkCheckoutButton() {
      const checkoutButton = document.querySelector('.fn-checkout-button');
      const consentStorage = sessionStorage.getItem('consent');
      const consentInputs = [...document.querySelectorAll('.fn-consent-input')];
      if ( consentStorage && consentStorage == 'accepted') {
        consentInputs.length > 0 && consentInputs.forEach(input => {
          input.checked = true;
        })
      } else {
        if(checkoutButton) {
          checkoutButton.classList.add('fn-disabled');
          checkoutButton.disabled = true;
        }
      }
      consentInputs.length > 0 && consentInputs.forEach(input => {
        input.addEventListener('change', () => {
          if (input.checked) {
            consentInputs.forEach((otherInput) => {
              if (otherInput !== input) {
                otherInput.parentElement.classList.remove('fn-error');
                otherInput.checked = false;
              }
            });
            if(checkoutButton) {
              checkoutButton.classList.remove('fn-disabled');
              checkoutButton.disabled = false;
            }
            sessionStorage.setItem('consent', 'accepted');
          } else {
            consentInputs.forEach((otherInput) => {
              if (otherInput !== input) {
                otherInput.parentElement.classList.remove('fn-error');
                otherInput.checked = false;
              }
            });
            if (checkoutButton) {
              checkoutButton.classList.add('fn-disabled');
              checkoutButton.disabled = true;
            }
            sessionStorage.setItem('consent', 'disabled');
          }
        });
      })
    }

    renderContents(parsedState) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
      this.doCartSlider();
      this.checkCheckoutButton();
    }

    getSectionsToRender() {
      return [
        // {
        //   id: 'cart-notification-product',
        //   selector: `#cart-notification-product-${this.productId}`,
        // },
        // {
        //   id: 'cart-notification-button'
        // },
        {
          id: 'cart-overlay',
          section: document.getElementById('cart-overlay').dataset.id,
          selector: '.js-contents',
        },
        {
          id: 'cart-overlay-footer',
          section: document.getElementById('cart-overlay-footer').dataset.id,
          selector: '.js-contents'
        },
        {
          id: 'cart-icon-bubble'
        }
      ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

